import React, { useState, useMemo } from "react";

const initialState = {
  action: "",
  emotion: "",
  date: "",
  helpful: false,
};

export const Context = React.createContext();

const Store = ({ children }) => {
  const [wellnessDataPoint, setWellnessDataPoint] = useState(initialState);

  const wellnessData = useMemo(
    () => [
      {
        action: wellnessDataPoint.action,
        emotion: wellnessDataPoint.emotion,
        date: wellnessDataPoint.date,
        helpful: wellnessDataPoint.helpful,
      },
      setWellnessDataPoint,
    ],
    [
      wellnessDataPoint.action,
      wellnessDataPoint.emotion,
      wellnessDataPoint.date,
      wellnessDataPoint.helpful,
    ]
  );

  return <Context.Provider value={wellnessData}>{children}</Context.Provider>;
};

export default Store;
